import React from 'react';
export function AboutSection() {
  return <section id="about" className="py-16 bg-white" data-id="element-20" data-mp="3nndggy8go13o">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21" data-mp="2lbn5v89h3vk0">
        <div className="flex flex-col-reverse md:flex-row items-center" data-id="element-22" data-mp="2lac5zjj5f7y6">
          <div className="md:w-1/2 mt-10 md:mt-0 md:pr-8" data-id="element-23" data-mp="2gbitnufllmzl">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1Vo3pPx4TJeT8NMbqJXVSQ/Meet_the_Bookkeeper.jpg" alt="Professional bookkeeper" className="w-full h-auto rounded-lg shadow-lg" data-id="element-24" data-mp="2beinljir0k8h" />
          </div>
          <div className="md:w-1/2 md:pl-8" data-id="element-25" data-mp="22juetjdyskex">
            <h2 className="text-3xl font-bold text-[#3A4A46] mb-6" data-id="element-26" data-mp="1xnnk6mr0qvca">
              Meet Your Bookkeeper & Tax Professional
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-27" data-mp="1sleohimrhf6h">
              <span className="font-bold" data-id="element-28" data-mp="1noo7mt34ufk0">
                Feeling overwhelmed by your books?
              </span>
            </p>
            <p className="text-gray-600 mb-6" data-id="element-29" data-mp="1jncsxilsreql">
              Whether you're just starting out, unsure if your financials are
              accurate, or feeling unprepared for tax time or a lender, you're
              not alone. Many small business owners feel the same way.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-30" data-mp="iv7tortmj1vq">
              <span className="font-bold" data-id="element-31" data-mp="nsznxshqr033">I get it-and I can help.</span>
            </p>
            <p className="text-gray-600 mb-6" data-id="element-32" data-mp="nqn6rhjt4tr3">
              I help small business owners clean up their finances, stay on top
              of the numbers, and actually understand what's going on in their
              business.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-33" data-mp="12gufv6nxd0f4">
              <span className="font-bold" data-id="element-34" data-mp="12jyvd06ubil3">Hi, I'm Jaime.</span>
            </p>
            <p className="text-gray-600 mb-6" data-id="element-35" data-mp="16hwkk30m24oh">
              I'm a former lender turned bookkeeper, which means I know exactly
              what banks, lenders, and tax pros want to see-and how to make sure
              your financials are ready for it. With a background in banking,
              finance, and bookkeeping, I bring a unique perspective to
              organizing your numbers and keeping you compliant.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-36" data-mp="1o16bbcnfe9f3">
              <span className="font-bold" data-id="element-37" data-mp="1nzv93h9mp9q3">Here's my approach:</span>
            </p>
            <ol className="list-decimal pl-5 text-gray-600 mb-6" data-id="element-38" data-mp="1j11wdr261mqz">
              <li className="mb-2" data-id="element-39" data-mp="1f0hw4emaq30m">Get your books organized and accurate.</li>
              <li className="mb-2" data-id="element-40" data-mp="1eyf2lklxprr5">Keep them up-to-date every month.</li>
              <li className="mb-2" data-id="element-41" data-mp="19ztyvb7h4pxy">
                Help you understand your numbers so you can make confident
                decisions.
              </li>
            </ol>
            <p className="text-gray-600 mb-6" data-id="element-42" data-mp="1040re68m3mn1">
              <span className="font-bold" data-id="element-43" data-mp="105bue3u8gqd3">The result?</span>
            </p>
            <p className="text-gray-600" data-id="element-44" data-mp="2zftd36py95kg">
              Less stress. More clarity. Confidence in your money-and your
              business.
            </p>
          </div>
        </div>
      </div>
    </section>;
}